module.exports = __webpack_public_path__ + "img/ptslogo.48693e6a.png";